import clockIconSVG from 'icons/clock.svg';
import { FunctionComponent } from 'preact';
import { useTranslation } from 'react-i18next';
import { ReactSVG } from 'react-svg';
import { isAvailableToday, OperatingHoursByService } from '../../services';
import {
  Container,
  IconContainer,
  OpeningContainer,
  HoursContainer,
  Day,
  DayOfWeek,
} from './DropOffOpeningHours.styles';

const ICON_SIZE = 24;

interface DropOffOpeningHoursProps {
  operatingHours: OperatingHoursByService[];
}

const DropOffOpeningHours: FunctionComponent<DropOffOpeningHoursProps> = ({
  operatingHours,
}) => {
  const { t } = useTranslation();

  const getAvailableHours = (
    firstOpenHours: string,
    secondOpenHours: string,
  ) => {
    if (!firstOpenHours && !secondOpenHours) {
      return t('RETURN_CLOSED_TEXT');
    }

    if (!secondOpenHours) return firstOpenHours;

    if (!firstOpenHours) return secondOpenHours;

    return `${firstOpenHours}, ${secondOpenHours}`;
  };

  const getDayTranslationKey = (day: string): string => {
    // Convert "Monday" to "DAY_MONDAY"
    return `DAY_${day.toUpperCase()}`;
  };

  return (
    <>
      <Container data-testid="opening-hours-container">
        <IconContainer>
          <ReactSVG
            src={clockIconSVG}
            width={ICON_SIZE}
            height={ICON_SIZE}
            aria-hidden
          />
        </IconContainer>
        <p>{t('OPENING_HOURS')}</p>
      </Container>
      <OpeningContainer iconSize={ICON_SIZE}>
        {operatingHours.map(({ serviceName, openingHours }) => (
          <HoursContainer data-testid="hours-container">
            {serviceName && <p>{serviceName}</p>}
            {openingHours.map(
              ({ operatingDay, firstOpenHours, secondOpenHours }) => (
                <Day
                  data-testid={`day-${
                    isAvailableToday(operatingDay) ? 'today' : 'other'
                  }`}
                  isToday={isAvailableToday(operatingDay)}
                >
                  <DayOfWeek data-testid="day-of-week">
                    {t(getDayTranslationKey(operatingDay))}
                  </DayOfWeek>
                  <p>{getAvailableHours(firstOpenHours, secondOpenHours)}</p>
                </Day>
              ),
            )}
          </HoursContainer>
        ))}
      </OpeningContainer>
    </>
  );
};

export { DropOffOpeningHours };
